import { useTranslation } from 'react-i18next';
import { Badge } from '../components/Badge';
import { Button } from '../components/Button';
import './Hero.css';

export function Hero() {
  const { t } = useTranslation();

  return (
    <section className="hero">
      <div className="container hero__inner">
        <div className="hero__copy">
          <Badge>{t('hero.badge')}</Badge>
          <h1 className="hero__title">{t('hero.title')}</h1>
          <p className="hero__subtitle">{t('hero.subtitle')}</p>
          <div className="hero__ctas">
            <Button as="a" href="#capabilities" size="lg">{t('hero.ctaPrimary')}</Button>
            <Button as="a" href="#newsletter" size="lg" variant="ghost">{t('hero.ctaSecondary')}</Button>
          </div>
          <div className="hero__stat">
            <span className="hero__stat-number">{t('hero.statNumber')}</span>
            <p className="hero__stat-label">{t('hero.statLabel')}</p>
          </div>
        </div>

        <div className="hero__mockup" aria-hidden="true">
          <div className="hero__mockup-chrome">
            <span className="hero__mockup-dot hero__mockup-dot--red" />
            <span className="hero__mockup-dot hero__mockup-dot--yellow" />
            <span className="hero__mockup-dot hero__mockup-dot--green" />
            <span className="hero__mockup-title">{t('hero.mockup.windowTitle')}</span>
          </div>
          <div className="hero__mockup-body">
            <div className="hero__mockup-tabs">
              <span className="hero__mockup-tab hero__mockup-tab--active">{t('hero.mockup.tabs.agenda')}</span>
              <span className="hero__mockup-tab">{t('hero.mockup.tabs.notes')}</span>
              <span className="hero__mockup-tab">{t('hero.mockup.tabs.agreements')}</span>
              <span className="hero__mockup-tab">{t('hero.mockup.tabs.history')}</span>
            </div>
            <div className="hero__mockup-rows">
              <div className="hero__mockup-row">
                <span className="hero__mockup-check hero__mockup-check--done" />
                <span className="hero__mockup-text hero__mockup-text--strike">{t('hero.mockup.tasks.roadmap')}</span>
              </div>
              <div className="hero__mockup-row">
                <span className="hero__mockup-check" />
                <span className="hero__mockup-text">{t('hero.mockup.tasks.blockers')}</span>
                <span className="hero__mockup-owner">Ana</span>
              </div>
              <div className="hero__mockup-row">
                <span className="hero__mockup-check" />
                <span className="hero__mockup-text">{t('hero.mockup.tasks.launchDate')}</span>
                <span className="hero__mockup-owner">Oscar</span>
              </div>
              <div className="hero__mockup-row hero__mockup-row--agreement">
                <span className="hero__mockup-pill">{t('hero.mockup.agreementLabel')}</span>
                <span className="hero__mockup-text">{t('hero.mockup.tasks.shipMvp')}</span>
                <span className="hero__mockup-owner hero__mockup-owner--coral">{t('hero.mockup.plannerLink')}</span>
              </div>
            </div>
          </div>
          <p className="hero__mockup-caption">{t('hero.mockupCaption')}</p>
        </div>
      </div>
    </section>
  );
}
